var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6C24.6274 6 30 11.3726 30 18C30 24.6274 24.6274 30 18 30C11.3726 30 6 24.6274 6 18C6 11.3726 11.3726 6 18 6ZM18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8ZM17.7035 21.6976C18.3273 21.6976 18.8201 22.202 18.8201 22.8447C18.8201 23.4875 18.3273 24 17.7035 24C17.0798 24 16.5792 23.4875 16.5792 22.8447C16.5792 22.202 17.0798 21.6976 17.7035 21.6976ZM17.9807 12C20.0677 12 21.5 13.2529 21.5 15.0915C21.5 16.3363 20.9147 17.1905 19.8674 17.8495C18.8586 18.4678 18.6122 18.8583 18.5506 19.5986C18.4736 20.1356 18.2118 20.4692 17.6881 20.4692C17.1447 20.4692 16.827 20.0903 16.7844 19.5607L16.7794 19.4359V19.2814C16.7794 18.3398 17.1953 17.6959 18.0334 17.1247L18.2195 17.0034C19.1744 16.3932 19.4978 15.9458 19.4978 15.1647C19.4978 14.278 18.8432 13.6597 17.896 13.6597C17.0413 13.6597 16.4714 14.1071 16.225 14.9288C16.0556 15.4332 15.7706 15.6366 15.3471 15.6366C14.8157 15.6366 14.5 15.2949 14.5 14.7498C14.5 14.4 14.5693 14.099 14.7156 13.7898C15.1931 12.6834 16.3944 12 17.9807 12Z",
    fill: "#111015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideBtn);
export default __webpack_public_path__ + "static/media/guide_btn.7fb754e5c56e3f13fd7eb5955127339e.svg";
export { ForwardRef as ReactComponent };